import React from 'react';
import { makeStyles } from '@mui/styles';
// import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Table from './ExpiredTable';
import MultiOrgDropDown from './MultiOrg';
import {LoadingSkeletonGroupWise, LoadingSkeletonTableWise} from '../components/LoadingSkeleton';
import { useSelector } from "react-redux";
import { selectEmail } from "../reducer/authSlice";
const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  btnPadding: {
    marginRight: "8px",
    marginBottom: "8px",
    fontSize: "0.8rem",
    fontWeight: 500,
    minHeight: "36px",
    borderRadius: "8px",
    textTransform: "none",
    padding: "6px 16px",
    transition: "all 0.2s ease",
    '&:hover': {
      transform: "translateY(-1px)",
      boxShadow: "0 4px 12px rgba(111, 41, 129, 0.2)",
    },
    '@media (max-width: 600px)': {
      fontSize: "0.75rem",
      minHeight: "32px",
      padding: "5px 12px",
      marginRight: "6px",
      marginBottom: "6px",
    },
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    '@media (max-width: 600px)': {
      minHeight: '120px',
    },
  },
  content: {
    flexGrow: 80,
    padding: theme.spacing(3),
    width: '100%',
    boxSizing: 'border-box',
    overflow: 'hidden',
    '@media (max-width: 600px)': {
      padding: theme.spacing(2),
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
    },
  },
  buttonContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    gap: '0',
    marginBottom: '16px',
    '@media (max-width: 600px)': {
      gap: '0',
      marginBottom: '12px',
    },
  },
}));

export default function FullWidthGrid(props) {
  const classes = useStyles();
  const email = useSelector(selectEmail);
  const { handleIconCLick, loading, _setLoading, _dispatch, buttonArray, _started, _pending, buttonName, setButtonClicked, typeButton, setSelectedType, selectTypeButton,handleHome, menuTitle, setMenuTitle,selectedTab ,setSelectedTab} = props;
  const [tableData, setTabledata] = React.useState({});

  const handleGroupClick = (item) => {
    setButtonClicked(item);

    if (buttonArray[selectTypeButton] !== undefined) {
      setTabledata(buttonArray[selectTypeButton][item]);

    }
  }

  console.log('tabledata', tableData)

  React.useEffect(() => {
    let isMounted = true;

    // Compute the correct key based on typeButton
    let computedType = '';
    if(typeButton === 'FeedbackExpired'){
      if (isMounted) setMenuTitle(['Feedback','FeedbackCompleted','FeedbackExpired'])
      computedType = 'FEEDBACK_EXPIRED';
    }else if(typeButton === 'SurveyExpired'){
      if (isMounted) setMenuTitle(['Survey','SurveyCompleted','SurveyExpired'])
      computedType = 'SURVEY_EXPIRED';
    }else if(typeButton === 'WorkFlowExpired'){
      if (isMounted) setMenuTitle(['WorkFlow','WorkFlowCompleted','WorkFlowExpired'])
      computedType = 'WORKFLOW_EXPIRED';
    }else{
      if (isMounted) setMenuTitle(['Tests','Completed','Expired'])
      computedType = 'EXPIRED';
    }
    if (isMounted) setSelectedType(computedType);

    // Use computedType directly instead of selectTypeButton to avoid stale state
    if (buttonArray[computedType] !== undefined && buttonArray[computedType][Object.keys(buttonArray[computedType])[0]] !== undefined) {
      if (isMounted) {
        setButtonClicked(Object.keys(buttonArray[computedType])[0]);
        setTabledata(buttonArray[computedType][Object.keys(buttonArray[computedType])[0]]);
      }
    }else{
      if (isMounted) setTabledata({})
    }

    return () => {
      isMounted = false;
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [buttonArray, typeButton])

  return (
    <main className={classes.content}>
      <div className={classes.toolbar} />
      <b>Login ID:</b> {email}
      <br></br>
      <br></br>
      <div className='row'>
        <MultiOrgDropDown selectedTab = {selectedTab} setSelectedTab = {setSelectedTab} handleIconCLick={handleIconCLick} handleHome={handleHome} typeButton={typeButton} menuTitle={menuTitle}/>
      </div>
      {/* <p className="button-text" style={{color: '#B45E9B',marginBottom:"0px"}}>Kindly click on the 'Link' under Action column to proceed:</p>
  */}
      <br></br>
      {loading ? <LoadingSkeletonGroupWise />  :
      <Grid style={{ paddingBottom: "0px" }} item xs={12}>
        <div className={classes.buttonContainer}>
        {buttonArray[selectTypeButton] !== undefined ?
          // eslint-disable-next-line array-callback-return
          Object.keys(buttonArray[selectTypeButton]).map((item, index) => {
            if (item !== 'tableHeaders') {
              return (<Button key={`gButton${index}`} className={classes.btnPadding}
                variant="outlined" color={(buttonName === item) ? "primary" : "default"}
                style={{background: (buttonName === item) ? 'rgba(111, 41, 129, 0.13)' : ''}}
                onClick={() => handleGroupClick(item)}>
                {item}
              </Button>)
            }
          }) :
          <></>
        }
        </div>
      </Grid>}

      <Grid item xs={12}>

        {/* <Paper className={classes.paper}>xs=12 sm=6</Paper> */}
        {loading ? <LoadingSkeletonTableWise /> :
        <Table tableData={tableData} typeButton={typeButton} status='000' />
        }


      </Grid>
      {/* <Grid item xs={12} >
          <h2>Not Started</h2>

            <Table tableData={tableData} typeButton={typeButton} status='001' />
          </Grid> */}

    </main>
  );
}